module.exports = __webpack_public_path__ + "img/logo-en-botton-gradiant.d804266.svg";